import axios from 'axios';
import authHeader from '../auth-header';

const NODE_ENV = process.env.NODE_ENV;
const PROTOCOL = process.env.PROTOCOL || 'http://';
const END_POINT_URL = process.env.END_POINT_URL || window.location.hostname;
const END_POINT_PORT = process.env.END_POINT_PORT || '8080';

const API_URL = NODE_ENV === 'production' ? PROTOCOL + END_POINT_URL + '/api/player/' : PROTOCOL + END_POINT_URL + ':' + END_POINT_PORT + '/api/player/';

class PlayerService {
  getPlayer(playerId) {
    return axios.get(API_URL  + playerId);
  }

  getPlayerLollipop(playerId, seasonIds, teamIds, positionId, positionIdsPlayed,
  clientId, radarId, minMax, allPositions, compareSeasonId, url, zone, browser, metaInfo = null){
    let options = {
      params:{
        url, zone, browser, metaInfo
      }
    }
    return axios.get(API_URL + "lollipop/" + playerId + "/seasons/" + seasonIds + "/team/" + teamIds
    + "/position/" + positionId + "/positions-played/" + positionIdsPlayed + "/client/" + clientId
    + "/radar/" + radarId + "/min-max/" + minMax + "/all-positions/" + allPositions
    + "/compare-season/" + compareSeasonId, options);
  }

  getPlayerOrlegiRanking(playerId,seasonId,position){
    return axios.get(`${API_URL}${playerId}/${seasonId}/${position}/o-ranking`);
  }

  getXTOfPlayerAndSeasons(playerId, teamIds, seasonIds) {
    return axios.get(API_URL + 'player-threat/' + playerId + '/teams/' + teamIds + '/seasons/' + seasonIds);
  }

  getGamesPlayedSince(playerId, year) {
    return axios.get(API_URL + 'games-played-since/' + playerId + '/year/' + year);
  }

  getPlayerTeamSeasonData(playerId, clientId) {
    return axios.get(API_URL + 'player-season-data/' + playerId + '/client/' + clientId);
  }

  getGamesPlayedBySeasonIdAndTeamIdAndPlayerId(seasonId, teamId, playerId) {
    return axios.get(API_URL + 'season-games-played/' + seasonId + '/team/' + teamId + '/player/' + playerId);
  }

  getPlayerPosition(playerId) {
    return axios.get(API_URL + 'position/' + playerId);
  }

  getPlayerHistory(playerId) {
    return axios.get(API_URL + 'history/' + playerId);
  }

  getPlayerPositions(playerId) {
    return axios.get(API_URL + 'positions/' + playerId);
  }

  getPlayerInjuries(playerId) {
    return axios.get(API_URL + 'injuries/' + playerId);
  }

  getPlayerTransfers(playerId) {
    return axios.get(API_URL + 'transfer-history/' + playerId);
  }

  getYearPositions(playerId) {
    return axios.get(API_URL + 'year-positions/' + playerId);
  }

  getPlayerNationalTeamApperances(playerId) {
    return axios.get(API_URL + 'cap/' + playerId);
  }

  getPositionsPlayedOfPlayer(playerId, teamIds, seasonIds) {
    return axios.get(API_URL + "positions-played/player/"+ playerId +"/team/"+ teamIds + "/seasons/"+ seasonIds);
  }

  getShortPositionsPlayedOfPlayer(playerId, teamIds, seasonIds) {
    return axios.get(API_URL + "short-positions-played/player/"+ playerId + "/team/"+ teamIds + "/seasons/" + seasonIds);
  }

  getAllGamesOfPlayer(playerId) {
    return axios.get(API_URL + "all-games/player/"+ playerId);
  }

  getGamesPlayedOfPlayer(playerId, gameIdsOnly = false) {
    return axios.get(API_URL + "games-played/"+ playerId, {params: {gameIdsOnly}});
  }

  getGamesPlayedOfAPlayerForArrigoBySeason(seasonId, playerId) {
    return axios.get(API_URL + `games-played-arrigo/season/${seasonId}/player/${playerId}`);
  }

  getPlayerProfiles(playerId) {
      return axios.get(API_URL + "profiles/player/"+ playerId);
  }

  getPlayerProfilesRiv(playerId) {
    return axios.get(API_URL + "profiles-riv/player/"+ playerId);
  }

  postPlayerReport(userId, playerId, petition) {
    return axios.post(API_URL + 'report',
      {
        userId: userId,
        playerId: playerId,
        petition: petition,
      }
     );
  }

  postRequestPlayerReport(request) {
    return axios.post(API_URL + 'report',
      request
     );
  }

  postPlayerFollow(userId, playerId) {
    return axios.post(API_URL + 'follow',
      {
        userId: userId,
        playerId: playerId
      }
     );
  }

  getFollowedPlayers(userId,onlySelf) {
    return axios.get(API_URL + 'follow/' + userId, { headers: authHeader(),params:{onlySelf} });
  }

  getFavAndCollection(userId) {
    return axios.get(API_URL + 'follow-and-collection/' + userId, { headers: authHeader() });
  }

  getLastPlayersSearch(n) {
    return axios.get(API_URL + 'last-search/' + n);
  }

  getPlayersByGamesAndTeam(gameIds,teamId) {
    return axios.get(`${API_URL}game/${gameIds}/team/${teamId}`);
  }

  getPlayerGbe(playerId) {
    return axios.get(`${API_URL}${playerId}/gbe/`);
  }

  getNPlayersOfSeason(seasonId,nPlayers) {
    return axios.get(`${API_URL}${seasonId}/n/${nPlayers}`);
  }

  getPlayerSearchHistory(playerId) {
    return axios.get(`${API_URL}${playerId}/search-history`);
  }

  getFmfStats(playerId,seasonId, teamId) {
    return axios.get(`${API_URL}${playerId}/fmf-stats/${seasonId}/team/${teamId}`);
  }

  getSimilarityPlayers(playerId,teamId,radarSeasonId,seasonIds,countries,minMinutes,minAge,maxAge,minHeight,minScore,maxScore,mainPositions,secondaryPositions,
    freeAgentDate,minMarketValue,maxMarketValue,profileIds, footIds){
      return axios.get(`${API_URL}${playerId}/team/${teamId}/radar-season/${radarSeasonId}/similar/seasons/${seasonIds}/countries/${countries}/min-minutes/${minMinutes}
        /min-age/${minAge}/max-age/${maxAge}/min-height/${minHeight}/min-score/${minScore}/max-score/${maxScore}/main-positions/${mainPositions}
        /secondary-positions/${secondaryPositions}/free-agent-date/${freeAgentDate}/min-mv/${minMarketValue}/max-mv/${maxMarketValue}/profileIds/${profileIds}/foot/${footIds}`);
  }

  updateDallasPositionId(playerId, dallasPositionId){
    return axios.post(`${API_URL}${playerId}/dallas-position/${dallasPositionId}`);
  }

  getPlayerHasVideo(playerId) {
    return axios.get(`${API_URL}${playerId}/has-video`);
  }

  getFieldPositions() {
    return axios.get(`${API_URL}field-positions`);
  }

  getGamesStats(playerId,gameIds){
    return axios.get(`${API_URL}${playerId}/game/${gameIds}/stats`);
  }

  postPlayer(player){
    return axios.post(`${API_URL}`, player);
  }

  switchPinnedPlayerFav(playerId, pinned){
    return axios.put(`${API_URL}${playerId}/pinned/${pinned}`);
  }

  getSeasonPhysicalDataByGame(playerId,seasonId){
    return axios.get(`${API_URL}${playerId}/stats-pd/season/${seasonId}`);
  }

  updateFoot(playerId,footId){
    return axios.put(`${API_URL}${playerId}/foot/${footId}`);
  }

  getGPILatestValues(playerId, numOfGames) {
    return axios.get(`${API_URL}${playerId}/latest-gpi/${numOfGames}`);
  }

  getPlayerSetPieces(playerId,seasonId) {
    return axios.get(`${API_URL}${playerId}/season/${seasonId}/set-piece`);
  }

  getPlayerCrossings(playerId, seasonId) {
    return axios.get(`${API_URL}${playerId}/season/${seasonId}/crossings`);
  }

  getPlayersSeasonStatByLeague(seasonId, leagueId, statId) {
    return axios.get(`${API_URL}global/season/${seasonId}/league/${leagueId}/stat/${statId}`);
  }

  getArrigoPlayersByClient() {
    return axios.get(API_URL + 'arrigo-players');
  }

  getPlayersRankingByGPI(currentPage, size = 20, continentIds = null, leagueIds = null, teamIds = null, countryIds = null, primaryPosition = null, secondaryPosition = null, minMarketValue = 0, maxMarketValue = 9999999, minAge = 0, maxAge = 100, contractExpMonth, contractExpYear, freePlayers = false, searchedPlayer = '') {
    let url = `${API_URL}global/gpi?page=${currentPage}&size=${size}`;
    if (continentIds) {
      url += `&continentIds=${continentIds.join(',')}`;
    }
    if (leagueIds) {
      url += `&leagueIds=${leagueIds.join(',')}`;
    }
    if (teamIds) {
      url += `&teamIds=${teamIds.join(',')}`;
    }
    if (countryIds) {
      url += `&countryIds=${countryIds.join(',')}`;
    }

    url += `&primaryPosition=${primaryPosition}`;
    url += `&secondaryPosition=${secondaryPosition}`;

    url += `&minMarketValue=${minMarketValue}`;
    url += `&maxMarketValue=${maxMarketValue}`;

    url += `&minAge=${minAge}`;
    url += `&maxAge=${maxAge}`;

    if (contractExpMonth) {
      url += `&contractExpMonth=${contractExpMonth}`;
    }
    if (contractExpYear) {
      url += `&contractExpYear=${contractExpYear}`;
    }

    url += `&freePlayers=${freePlayers}`;

    url += `&searchedPlayer=${searchedPlayer}`;

    return axios.get(url);
  }

  getPlayerGPIHistory(playerIds, dateFrom, dateTo) {
    const params = new URLSearchParams();

    if (Array.isArray(playerIds)) {
      playerIds.forEach(id => {
        params.append('playerIds', id);
      });
    }
    params.append('dateFrom', dateFrom);
    params.append('dateTo', dateTo);
    
    return axios.get(`${API_URL}global/gpi/history?${params.toString()}`);
  }

  getOBREvents(seasonId,playerId){
    return axios.get(`${API_URL}${playerId}/season/${seasonId}/obr-events`)
  }

  getCountryAndAge(playerId) {
    return axios.get(`${API_URL}${playerId}/country-age`);
  }
  
  deletePlayerFavorites(userId, playerIds) {
    return axios.post(`${API_URL}follow/players/bulk-delete`, { userId, playerIds });
  }

}
export default new PlayerService();


// WEBPACK FOOTER //
// ./src/services/player/player.service.js